module.exports = ".example-icon {\n    padding: 0 14px;\n}\n\n.example-spacer {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto;\n}\n\n.son-header {\n    background-color: #2c4957 !important;\n}\n\n.navbar-logo img {\n    vertical-align: middle;\n    width: 165px;\n}\n\n.menu-spacer {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/navbar/navbar.component.css
// module id = ./src/app/common/navbar/navbar.component.css
// module chunks = main